import { Auth } from "aws-amplify";
import axios from "axios";
import { getApiEndpoints } from "../config/apiConfig";

export const Api = async () => {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    
    // Get the current environment from localStorage
    const storedEnvironment = localStorage.getItem('idwal-environment') as 'development' | 'staging' | 'production';
    const environment = storedEnvironment || 'production'; // Default to production if not set
    
    // Get the API endpoint for the current environment
    const apiEndpoints = getApiEndpoints(environment);
    const apiBaseUrl = apiEndpoints.idwalApi;
    
    return axios.create({
        baseURL: apiBaseUrl,
        headers: {
            "Content-Type": "application/json",
            Authorization: token
        }
    });
};

export const CircuitBreakerApi = async () => {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    
    // Get the current environment from localStorage
    const storedEnvironment = localStorage.getItem('idwal-environment') as 'development' | 'staging' | 'production';
    const environment = storedEnvironment || 'production'; // Default to production if not set

    // Get the API endpoint for the current environment
    const apiEndpoints = getApiEndpoints(environment);
    const apiBaseUrl = apiEndpoints.circuitBreakerApi;

    return axios.create({
        baseURL: apiBaseUrl,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            Authorization: token
        }
    });
};

export const CircuitBreakerRetrievalApi = async () => {
    // Get the current environment from localStorage
    const storedEnvironment = localStorage.getItem('idwal-environment') as 'development' | 'staging' | 'production';
    const environment = storedEnvironment || 'production'; // Default to production if not set

    // Get the API endpoint for the current environment
    const apiEndpoints = getApiEndpoints(environment);
    const apiBaseUrl = apiEndpoints.circuitBreakerFunctionApi;

    
    return axios.create({
        baseURL: apiBaseUrl,
        headers: {
            "Accept": "application/json",
        }
    });
};

export const OrchestrationApi = async () => {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    
    // Get the current environment from localStorage
    const storedEnvironment = localStorage.getItem('idwal-environment') as 'development' | 'staging' | 'production';
    const environment = storedEnvironment || 'production'; // Default to production if not set
    
    // Get the API endpoint for the current environment
    const apiEndpoints = getApiEndpoints(environment);
    const apiBaseUrl = apiEndpoints.orchestrationApi;

    console.info(`Using ${environment} environment API: ${apiBaseUrl}`);
    
    return axios.create({
        baseURL: apiBaseUrl,
        headers: {
            "Content-Type": "application/json",
            Authorization: token
        }
    });
};

export const ShadowPulseApi = async () => {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    
    // Get the current environment from localStorage
    const storedEnvironment = localStorage.getItem('idwal-environment') as 'development' | 'staging' | 'production';
    const environment = storedEnvironment || 'production'; // Default to production if not set

    // Get the API endpoint for the current environment
    const apiEndpoints = getApiEndpoints(environment);
    const apiBaseUrl = apiEndpoints.shadowPulseApi;

    return axios.create({
        baseURL: apiBaseUrl,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            Authorization: token
        }
    });
};